import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedIn: false,
    pages: [],
    page: 0,
    nextCondition: true,
    navActive: '',
    notification_state: {
      active: false,
      correctTitle: "You've got it!",
      incorrectTitle: 'Not quite.'
    },
    preSurvey: {
      changeTrigger: 0 // incremented to trigger change watchers
      // survey responses will populate here
    },
    preSurveyData: [
      // data to be persisted to mLab
    ],
    postSurvey: {
      changeTrigger: 0 // not needed?
      // same as preSurvey
    },
    postSurveyData: [
      // data to be persisted to mLab
    ],
    postSurveyError: false,
    checkbox: {
      el: null,
      correct: 'incorrect',
      caption: 'default caption'
    },
    navigation: {
      back: {
        text: 'back',
        custom: ''
      },
      next: {
        text: 'next',
        custom: ''
      }
    }
  },
  mutations: {
    change_page (state, inc) {
      let new_page = state.page + inc
      if (-1 < new_page && new_page < state.pages.length) {
        state.page = new_page
      }
    },
    assign_page (state, ind) {
      state.page = ind
    },
    set_navigation_next (state, payload) {
      Object.assign(state.navigation.next, payload)
    },
    set_navigation_back (state, payload) {
      Object.assign(state.navigation.back, payload)
    },
    set_notification (state, payload) {
      Object.assign(state.notification_state, payload)
    },
    set_checkbox (state, payload) {
      Object.assign(state.checkbox, payload)
    },
    set_pages (state, payload) {
      state.pages = payload
    },
    // set preSurvey and post Survey validations
    setPreSurvey (state, payload) {
      Object.assign(state.preSurvey, payload)
      state.preSurvey.changeTrigger += 1 // trigger change watchers
    },
    setPostSurvey (state, payload) {
      Object.assign(state.postSurvey, payload)
      state.postSurvey.changeTrigger += 1 // trigger change watchers
    },
    // set preSurvey and postSurvey data
    setPreSurveyData(state, payload) {
      for(let i = 0; i < state.preSurveyData.length; i ++) {
        if(state.preSurveyData[i].question === payload.question) {
          Object.assign(state.preSurveyData[i], payload)
          return
        }
      }
      state.preSurveyData.push(payload)
    },
    setPostSurveyData(state, payload) {
      for(let i = 0; i < state.postSurveyData.length; i ++) {
        if(state.postSurveyData[i].question === payload.question) {
          Object.assign(state.postSurveyData[i], payload)
          return
        }
      }
      state.postSurveyData.push(payload)
    },
    //
    setPostSurveyError (state, payload) {
      state.postSurveyError = payload
    },
    setNextCondition (state, payload) {
      state.nextCondition = payload
    },
    setLoggedIn (state, payload) {
      state.loggedIn = payload
    },
    setNavActive (state, payload) {
      state.navActive = payload
    }

  }
})




// WEBPACK FOOTER //
// ./src/store/index.js